import React, { Component } from 'react';

/**
 * Component which scroll when mounted
 */
export default class ScrollOnMount extends Component {
  componentDidMount = () => {
      window.scrollTo(0, 0);
  };

  render() {
    const {children, ...otherProps} = this.props;

    return React.cloneElement(children, otherProps);
  }
}


// WEBPACK FOOTER //
// ./src/components/ScrollOnMount.js